import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';

import { UnitIntelligenceRoutingModule } from './unit-intelligence-routing.module';
import { IntelligenceDashboardComponent } from './intelligence-dashboard/intelligence-dashboard.component';
import { IntelligenceRankingComponent } from './intelligence-ranking/intelligence-ranking.component';
import { IntelligenceHistoryComponent } from './intelligence-history/intelligence-history.component';
import { KpiCardComponent } from './shared/kpi-card/kpi-card.component';
import { SparklineComponent } from './shared/sparkline/sparkline.component';
import { DonutChartComponent } from './shared/donut-chart/donut-chart.component';
import { EfficiencyBadgeComponent } from './shared/efficiency-badge/efficiency-badge.component';
import { DateRangePickerComponent } from './shared/date-range-picker/date-range-picker.component';
import { RankingMiniPanelComponent } from './shared/ranking-mini-panel/ranking-mini-panel.component';
import { MonthPickerComponent } from './shared/month-picker/month-picker.component';
import { UnitMaintenanceHistoryComponent } from './unit-maintenance-history/unit-maintenance-history.component';
import { LineChartComponent } from './shared/line-chart/line-chart.component';

@NgModule({
    declarations: [
        IntelligenceDashboardComponent,
        IntelligenceRankingComponent,
        IntelligenceHistoryComponent,
        KpiCardComponent,
        SparklineComponent,
        DonutChartComponent,
        EfficiencyBadgeComponent,
        DateRangePickerComponent,
        RankingMiniPanelComponent,
        MonthPickerComponent,
        UnitMaintenanceHistoryComponent,
        LineChartComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        UnitIntelligenceRoutingModule,
        NgxSpinnerModule,
    ],
    exports: [
        KpiCardComponent,
        DonutChartComponent,
        SparklineComponent,
        LineChartComponent,
        DateRangePickerComponent,
    ]
})
export class UnitIntelligenceModule { }
